<template>
    <div class="pixso-page about-contact-page">
        <main class="about-contact-page__main">
            <div class="h-c banner banner--contact" :style="{ backgroundImage: `url(${contactHeroImage})` }">
                <div class="banner-overlay"></div>
                <div class="banner-company">
                    <p class="banner-company__name text-size-56">{{ t('Contact.companyName') }}</p>
                    <p class="banner-company__en text-size-20">{{ t('Contact.companyNameEn') }}</p>
                </div>
            </div>

            <div class="about-contact__hero-gap"></div>

            <div class="h-c">
                <div class="about-contact__title" id="contact-form">
                    <h2 class="text-size-96 about-contact__title-text">{{ t('Contact.title') }}</h2>
                </div>
            </div>

            <div class="about-contact__content-gap"></div>

            <div class="h-c">
                <div class="v-c about-contact__content">
                    <div class="contact-panel">
                        <section class="contact-location">
                            <h3 class="text-size-36 contact-location__title">{{ t('Contact.locations.wuhan.city') }}</h3>
                            <div class="div-spacer-h16"></div>

                            <div class="contact-line">
                                <span class="contact-line__dot" aria-hidden="true"></span>
                                <p class="text-size-20 contact-line__text">{{ t('Contact.locations.wuhan.phone') }}</p>
                            </div>
                            <div class="div-spacer-h16"></div>
                            <div class="contact-line">
                                <span class="contact-line__dot" aria-hidden="true"></span>
                                <p class="text-size-20 contact-line__text contact-line__text--multiline" data-text-reveal="off">{{ t('Contact.locations.wuhan.email') }}</p>
                            </div>
                            <div class="div-spacer-h16"></div>
                            <div class="contact-line">
                                <span class="contact-line__dot" aria-hidden="true"></span>
                                <p class="text-size-20 contact-line__text">{{ t('Contact.locations.wuhan.address') }}</p>
                            </div>

                            <div class="contact-line contact-line--extension">
                                <span class="contact-line__dot" aria-hidden="true"></span>
                                <div class="contact-extension">
                                    <p class="contact-extension__phone text-size-20">
                                        {{ t('Contact.locations.wuhan.extension.phone') }}
                                    </p>
                                    <p class="contact-extension__title text-size-20">
                                        {{ t('Contact.locations.wuhan.extension.title') }}
                                    </p>
                                    <ul class="contact-extension__list">
                                        <li
                                            v-for="item in wuhanExtensionItems"
                                            :key="item"
                                            class="contact-extension__item"
                                        >
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        <section class="contact-location">
                            <h3 class="text-size-36 contact-location__title">{{ t('Contact.locations.shenzhen.city') }}</h3>
                            <div class="div-spacer-h16"></div>

                            <div class="contact-line">
                                <span class="contact-line__dot" aria-hidden="true"></span>
                                <p class="text-size-20 contact-line__text">{{ t('Contact.locations.shenzhen.phone') }}</p>
                            </div>
                            <div class="div-spacer-h16"></div>
                            <div class="contact-line">
                                <span class="contact-line__dot" aria-hidden="true"></span>
                                <p class="text-size-20 contact-line__text contact-line__text--multiline" data-text-reveal="off">{{ t('Contact.locations.shenzhen.email') }}</p>
                            </div>
                            <div class="div-spacer-h16"></div>
                            <div class="contact-line">
                                <span class="contact-line__dot" aria-hidden="true"></span>
                                <p class="text-size-20 contact-line__text">{{ t('Contact.locations.shenzhen.address') }}</p>
                            </div>
                        </section>

                        <section class="contact-location">
                            <h3 class="text-size-36 contact-location__title">{{ t('Contact.locations.nanjing.city') }}</h3>
                            <div class="div-spacer-h16"></div>

                            <div class="contact-line">
                                <span class="contact-line__dot" aria-hidden="true"></span>
                                <p class="text-size-20 contact-line__text">{{ t('Contact.locations.nanjing.phone') }}</p>
                            </div>
                            <div class="div-spacer-h16"></div>
                            <div class="contact-line">
                                <span class="contact-line__dot" aria-hidden="true"></span>
                                <p class="text-size-20 contact-line__text contact-line__text--multiline" data-text-reveal="off">{{ t('Contact.locations.nanjing.email') }}</p>
                            </div>
                            <div class="div-spacer-h16"></div>
                            <div class="contact-line">
                                <span class="contact-line__dot" aria-hidden="true"></span>
                                <p class="text-size-20 contact-line__text">{{ t('Contact.locations.nanjing.address') }}</p>
                            </div>
                        </section>
                    </div>

                    <div class="form-panel">
                        <div class="form-container">
                            <form @submit.prevent="handleSubmit">
                                <div class="form-group">
                                    <label class="form-label required text-size-24">{{ t('Contact.form.name.label') }}</label>
                                    <input
                                        v-model="formData.customerName"
                                        class="form-input"
                                        type="text"
                                        :placeholder="t('Contact.form.placeholder')"
                                        :class="{ error: errors.customerName }"
                                        required
                                    >
                                    <span v-if="errors.customerName" class="error-text">{{ errors.customerName }}</span>
                                </div>

                                <div class="form-group">
                                    <label class="form-label required text-size-24">{{ t('Contact.form.company.label') }}</label>
                                    <input
                                        v-model="formData.customerCompany"
                                        class="form-input"
                                        type="text"
                                        :placeholder="t('Contact.form.placeholder')"
                                        :class="{ error: errors.customerCompany }"
                                        required
                                    >
                                    <span v-if="errors.customerCompany" class="error-text">{{ errors.customerCompany }}</span>
                                </div>

                                <div class="form-group">
                                    <label class="form-label required text-size-24">{{ t('Contact.form.position.label') }}</label>
                                    <input
                                        v-model="formData.customerTitle"
                                        class="form-input"
                                        type="text"
                                        :placeholder="t('Contact.form.placeholder')"
                                        :class="{ error: errors.customerTitle }"
                                        required
                                    >
                                    <span v-if="errors.customerTitle" class="error-text">{{ errors.customerTitle }}</span>
                                </div>

                                <div class="form-group">
                                    <label class="form-label required text-size-24">{{ t('Contact.form.contact.label') }}</label>
                                    <input
                                        v-model="formData.customerContact"
                                        class="form-input"
                                        type="text"
                                        :placeholder="t('Contact.form.contact.placeholder')"
                                        :class="{ error: errors.customerContact }"
                                        required
                                    >
                                    <span v-if="errors.customerContact" class="error-text">{{ errors.customerContact }}</span>
                                </div>

                                <div class="form-group">
                                    <label class="form-label text-size-24">{{ t('Contact.form.question.label') }}</label>
                                    <textarea
                                        v-model="formData.question"
                                        class="form-textarea"
                                        :placeholder="t('Contact.form.placeholder')"
                                    ></textarea>
                                </div>

                                <button
                                    class="submit-btn"
                                    type="submit"
                                    :aria-label="t('Contact.form.submit')"
                                >
                                    {{ t('Contact.form.submit') }}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="about-contact__footer-gap"></div>
        </main>

        <div v-if="showSuccessModal" class="modal">
            <div class="modal-content">
                <h3>{{ t('Contact.modal.success.title') }}</h3>
                <p>{{ t('Contact.modal.success.message') }}</p>
                <button :aria-label="t('Contact.modal.confirm')" @click="closeModal('success')">
                    {{ t('Contact.modal.confirm') }}
                </button>
            </div>
        </div>

        <div v-if="showErrorModal" class="modal">
            <div class="modal-content">
                <h3>{{ t('Contact.modal.error.title') }}</h3>
                <p>{{ t('Contact.modal.error.message') }}</p>
                <button :aria-label="t('Contact.modal.confirm')" @click="closeModal('error')">
                    {{ t('Contact.modal.confirm') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { useScrollAnimation } from '@/js/useScrollAnimation.js'

import contactHeroImage from '@/assets/images/pixso-contact/hero-contact.jpg'

useScrollAnimation()

const { t, tm } = useI18n()
const wuhanExtensionItems = computed(() => tm('Contact.locations.wuhan.extension.items'))

const formData = reactive({
    customerName: '',
    customerCompany: '',
    customerTitle: '',
    customerContact: '',
    question: ''
})

const errors = reactive({
    customerName: '',
    customerCompany: '',
    customerTitle: '',
    customerContact: ''
})

const showSuccessModal = ref(false)
const showErrorModal = ref(false)

const validateEmail = (email) => {
    const re = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
    return re.test(String(email).toLowerCase())
}

const validatePhone = (phone) => {
    const re = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
    return re.test(phone)
}

const validateForm = () => {
    let isValid = true

    Object.keys(errors).forEach(key => {
        errors[key] = ''
    })

    if (!formData.customerName.trim()) {
        errors.customerName = t('Contact.validation.name')
        isValid = false
    }

    if (!formData.customerCompany.trim()) {
        errors.customerCompany = t('Contact.validation.company')
        isValid = false
    }

    if (!formData.customerTitle.trim()) {
        errors.customerTitle = t('Contact.validation.title')
        isValid = false
    }

    if (!formData.customerContact.trim()) {
        errors.customerContact = t('Contact.validation.contact')
        isValid = false
    } else if (!validateEmail(formData.customerContact) && !validatePhone(formData.customerContact)) {
        errors.customerContact = t('Contact.validation.contactFormat')
        isValid = false
    }

    return isValid
}

const handleSubmit = async () => {
    if (!validateForm()) return

    const requestData = {
        customerName: formData.customerName,
        customerCompany: formData.customerCompany,
        customerTitle: formData.customerTitle,
        question: formData.question || ''
    }

    if (validateEmail(formData.customerContact)) {
        requestData.customerEmail = formData.customerContact
        requestData.customerPhone = '12345678910'
    } else {
        requestData.customerPhone = formData.customerContact
    }

    try {
        const response = await fetch('http://www.cx-botcnt.com/web-prod-api/customer/question/submit', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        })

        if (!response.ok) throw new Error(t('Contact.modal.error.title'))

        await response.json()
        showSuccessModal.value = true
        resetForm()
    } catch (error) {
        console.error('Error:', error)
        showErrorModal.value = true
    }
}

const resetForm = () => {
    Object.keys(formData).forEach(key => {
        formData[key] = ''
    })
    Object.keys(errors).forEach(key => {
        errors[key] = ''
    })
}

const closeModal = (type) => {
    if (type === 'success') {
        showSuccessModal.value = false
    } else {
        showErrorModal.value = false
    }
}
</script>

<style scoped>
.about-contact-page {
    --contact-color-bg: #fff;
    --contact-color-text: #000;
    --contact-color-text-soft: #111;
    --contact-color-text-muted: #333;
    --contact-color-accent: #acbf54;
    --contact-color-error: #ff4444;
    --contact-color-button-hover: #444;
    --contact-border-subtle: rgba(0, 0, 0, 0.1);
    --contact-divider-subtle: rgba(0, 0, 0, 0.12);
    --contact-overlay-bg: rgba(0, 0, 0, 0.4);
    --contact-field-bg: rgba(0, 0, 0, 0.05);
    --contact-focus-border: rgba(172, 191, 84, 0.65);
    --contact-focus-shadow: rgba(172, 191, 84, 0.12);
    --contact-modal-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
    --contact-hero-copy-max: 896px;
    --contact-hero-bottom: 489px;
    --contact-title-gap: var(--pixso-fs-96);
    --contact-content-gap: calc(var(--pixso-gap-lg) + calc(var(--pixso-gap-sm) - var(--pixso-gap-xs)));
    --contact-footer-gap: 349px;
    --contact-content-max: 1102px;
    --contact-content-height: 1014px;
    --contact-sidebar-width: 400px;
    --contact-form-width: 622px;
    --contact-column-gap: 80px;
    --contact-location-gap: 80px;
    --contact-form-group-gap: 60px;
    --contact-input-height: 50px;
    --contact-textarea-height: 184px;
    --contact-input-radius: 8px;
    --contact-button-width: 200px;
    --contact-button-height: 50px;
    --contact-button-radius: 40px;
    --contact-button-pill-radius: 999px;
    --contact-button-padding-y: 10px;
    --contact-button-padding-x: 60px;
    --contact-dot-size: 12px;
    --contact-dot-offset: 9px;
    --contact-modal-width: 440px;
    --contact-modal-radius: 20px;
    --contact-mobile-title-size: 44px;
    --contact-mobile-title-line: 51px;
    --contact-mobile-title-gap: 56px;
    --contact-mobile-row-gap: 40px;
    --contact-mobile-form-gap: var(--pixso-fs-28);
    --contact-mobile-input-height: var(--pixso-fs-48);
    --contact-mobile-textarea-height: 140px;
    --contact-mobile-input-padding-y: 10px;
    --contact-mobile-input-padding-x: 14px;
    --contact-mobile-dot-size: 10px;
    --contact-mobile-dot-offset: 7px;
    width: 100%;
    background: var(--contact-color-bg);
    color: var(--contact-color-text);
    overflow-x: clip;
}

.about-contact-page__main {
    width: 100%;
    background: var(--contact-color-bg);
    color: var(--contact-color-text);
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.about-contact-page__main .h-c {
    opacity: 1;
    transform: none;
}

.banner.banner--contact {
    justify-content: center;
    position: relative;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    height: var(--pixso-hero-height);
    min-height: var(--pixso-hero-min);
}

.banner-company {
    position: absolute;
    left: 50%;
    bottom: var(--contact-hero-bottom);
    transform: translateX(-50%);
    width: min(var(--contact-hero-copy-max), calc(100vw - var(--pixso-gap-lg)));
    z-index: 2;
    text-align: center;
    color: var(--pixso-color-text);
}

.banner-company__name {
    margin: 0;
    color: var(--pixso-color-text);
    font-family: var(--pixso-font-cn);
    font-weight: 700;
    line-height: var(--pixso-lh-56);
}

.banner-company__en {
    margin: var(--pixso-gap-sm) 0 0;
    color: var(--pixso-color-text);
    font-family: var(--pixso-font-en);
    line-height: var(--pixso-lh-20);
}

.banner-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.08);
    z-index: 1;
}

.about-contact__title {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.about-contact__hero-gap {
    height: var(--contact-title-gap);
}

.about-contact__content-gap {
    height: var(--contact-content-gap);
}

.about-contact__footer-gap {
    height: var(--contact-footer-gap);
}

.about-contact__title-text {
    margin: 0;
    color: var(--contact-color-text);
    font-family: var(--pixso-font-cn);
    font-weight: 700;
    letter-spacing: 0;
}

.about-contact__content {
    width: min(var(--contact-content-max), calc(100vw - var(--pixso-page-padding) * 2));
    max-width: none;
    min-height: var(--contact-content-height);
    margin: 0 auto;
    padding: 0;
    display: grid;
    grid-template-columns: var(--contact-sidebar-width) var(--contact-form-width);
    column-gap: var(--contact-column-gap);
    gap: 0 var(--contact-column-gap);
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    position: relative;
}

.about-contact__content::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(var(--contact-sidebar-width) - 1px);
    width: 1px;
    background: var(--contact-divider-subtle);
}

.contact-panel {
    width: var(--contact-sidebar-width);
    padding-right: var(--contact-column-gap);
    margin-right: 0;
    border-right: 0;
    text-align: left;
}

.contact-location + .contact-location {
    margin-top: var(--contact-location-gap);
}

.contact-location__title {
    margin: 0;
    color: var(--contact-color-text);
    font-family: var(--pixso-font-cn);
    font-weight: 700;
}

.contact-line {
    display: flex;
    align-items: flex-start;
    gap: var(--pixso-fs-16);
}

.contact-line--extension {
    margin-top: var(--pixso-gap-md);
}

.contact-line__dot {
    display: block;
    width: var(--contact-dot-size);
    height: var(--contact-dot-size);
    flex: 0 0 var(--contact-dot-size);
    margin-top: var(--contact-dot-offset);
    border-radius: 50%;
    background: var(--contact-color-accent);
}

.contact-line__text {
    margin: 0;
    color: var(--contact-color-text-soft);
    font-family: var(--pixso-font-cn);
}

.contact-line__text--multiline {
    white-space: pre-line;
}

.contact-extension {
    color: var(--contact-color-text-soft);
    font-family: var(--pixso-font-cn);
}

.contact-extension__phone,
.contact-extension__title {
    margin: 0;
    color: var(--contact-color-text-soft);
    font-weight: 700;
    line-height: var(--pixso-lh-20);
}

.contact-extension__title {
    margin-top: var(--pixso-gap-xs);
}

.contact-extension__list {
    display: flex;
    flex-direction: column;
    gap: var(--pixso-gap-xs);
    margin: var(--pixso-gap-sm) 0 0;
    padding: 0;
    list-style: none;
}

.contact-extension__item {
    margin: 0;
    color: var(--contact-color-text-muted);
    font-size: var(--pixso-fs-16);
    font-weight: 500;
    line-height: var(--pixso-lh-16);
}

.form-panel {
    width: var(--contact-form-width);
}

.form-container {
    width: 100%;
}

.form-group {
    margin-bottom: var(--contact-form-group-gap);
}

.form-group:last-of-type {
    margin-bottom: var(--contact-form-group-gap);
}

.form-label {
    display: block;
    margin-bottom: var(--pixso-fs-16);
    color: var(--contact-color-text);
    font-family: var(--pixso-font-cn);
    font-weight: 700;
}

.form-input {
    width: 100%;
    min-height: var(--contact-input-height);
    padding: calc(var(--pixso-gap-sm) - var(--pixso-gap-xs)) var(--pixso-fs-20);
    border: 1px solid var(--contact-border-subtle);
    border-radius: var(--contact-input-radius);
    background: var(--contact-field-bg);
    color: var(--contact-color-text-soft);
    font: inherit;
    font-family: var(--pixso-font-cn);
    font-size: var(--pixso-fs-20);
    line-height: var(--pixso-lh-20);
    -webkit-appearance: none;
    appearance: none;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-input::placeholder,
.form-textarea::placeholder {
    color: var(--pixso-color-muted);
    font: inherit;
    font-family: var(--pixso-font-cn);
}

.form-input:focus,
.form-textarea:focus {
    border-color: var(--contact-focus-border);
    box-shadow: 0 0 0 var(--pixso-gap-xs) var(--contact-focus-shadow);
}

.form-textarea {
    width: 100%;
    min-height: var(--contact-textarea-height);
    padding: calc(var(--pixso-gap-sm) - var(--pixso-gap-xs)) var(--pixso-fs-20);
    border: 1px solid var(--contact-border-subtle);
    border-radius: var(--contact-input-radius);
    background: var(--contact-field-bg);
    color: var(--contact-color-text-soft);
    font: inherit;
    font-family: var(--pixso-font-cn);
    font-size: var(--pixso-fs-20);
    line-height: var(--pixso-lh-20);
    resize: vertical;
    -webkit-appearance: none;
    appearance: none;
    outline: none;
}

.submit-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: var(--contact-button-width);
    height: var(--contact-button-height);
    padding: var(--contact-button-padding-y) var(--contact-button-padding-x);
    background-color: var(--contact-color-text);
    color: var(--pixso-color-text);
    border: none;
    border-radius: var(--contact-button-radius);
    cursor: pointer;
    font-family: var(--pixso-font-cn);
    font-size: var(--pixso-fs-20);
    font-weight: 700;
    line-height: var(--pixso-lh-20);
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.submit-btn:hover {
    opacity: 0.9;
}

.required::after {
    content: "";
}

.error {
    border-color: var(--contact-color-error);
}

.error-text {
    color: var(--contact-color-error);
    font-size: var(--pixso-fs-12);
    line-height: var(--pixso-lh-12);
    margin-top: calc(var(--pixso-gap-sm) - var(--pixso-gap-xs));
}

.modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    inset: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    padding: var(--pixso-gap-md);
    background-color: var(--contact-overlay-bg);
}

.modal-content {
    width: min(var(--contact-modal-width), 100%);
    padding: var(--pixso-fs-28) var(--pixso-gap-md);
    border-radius: var(--contact-modal-radius);
    background-color: var(--contact-color-bg);
    box-shadow: var(--contact-modal-shadow);
    text-align: center;
}

.modal-content h3 {
    margin: 0;
    font-size: var(--pixso-fs-24);
    line-height: var(--pixso-lh-24);
    color: var(--contact-color-text);
}

.modal-content p {
    margin: var(--pixso-gap-sm) 0 0;
    font-size: var(--pixso-fs-16);
    color: var(--contact-color-text-muted);
    line-height: var(--pixso-lh-16);
}

.modal-content button {
    margin-top: var(--pixso-gap-md);
    padding: var(--pixso-gap-sm) var(--pixso-fs-28);
    background-color: var(--contact-color-text);
    color: var(--pixso-color-text);
    border: none;
    border-radius: var(--contact-button-pill-radius);
    cursor: pointer;
    font-family: var(--pixso-font-cn);
    font-weight: 700;
}

.modal-content button:hover {
    background-color: var(--contact-color-button-hover);
}

@media (max-width: 768px) {
    .about-contact-page {
        --contact-hero-bottom: var(--pixso-gap-md);
        --contact-content-gap: var(--pixso-gap-lg);
        --contact-content-height: auto;
        --contact-footer-gap: var(--pixso-fs-96);
    }

    .banner.banner--contact {
        height: var(--pixso-hero-mobile);
        min-height: var(--pixso-hero-mobile);
        max-height: none !important;
        background-position: center top;
    }

    .banner-company {
        top: auto;
        bottom: var(--pixso-gap-md);
        width: calc(100vw - var(--pixso-page-padding) * 2);
    }

    .banner-company__name {
        line-height: var(--pixso-lh-20);
    }

    .banner-company__en {
        margin-top: calc(var(--pixso-gap-sm) - var(--pixso-gap-xs));
        line-height: var(--pixso-lh-12);
    }

    .about-contact__title-text {
        font-size: var(--pixso-fs-48);
        line-height: var(--pixso-lh-48);
    }

    .about-contact__hero-gap {
        height: var(--contact-mobile-title-gap);
    }

    .about-contact__content {
        width: calc(100vw - var(--pixso-page-padding) * 2);
        padding: 0;
        display: grid;
        grid-template-columns: 1fr;
        row-gap: var(--contact-mobile-row-gap);
        column-gap: 0;
        text-align: left;
    }

    .about-contact__content::before {
        display: none;
    }

    .contact-panel {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
        padding-bottom: var(--contact-mobile-row-gap);
        margin-bottom: 0;
        border-right: 0;
        border-bottom: 1px solid var(--contact-border-subtle);
    }

    .contact-location + .contact-location {
        margin-top: var(--pixso-gap-md);
    }

    .contact-line {
        gap: var(--pixso-gap-sm);
    }

    .contact-line__dot {
        width: var(--contact-mobile-dot-size);
        height: var(--contact-mobile-dot-size);
        flex-basis: var(--contact-mobile-dot-size);
        margin-top: var(--contact-mobile-dot-offset);
    }

    .form-panel {
        width: 100%;
    }

    .form-group {
        margin-bottom: var(--contact-mobile-form-gap);
    }

    .form-group:last-of-type {
        margin-bottom: var(--contact-mobile-form-gap);
    }

    .form-label {
        margin-bottom: var(--contact-mobile-input-padding-y);
    }

    .form-input,
    .form-textarea {
        min-height: var(--contact-mobile-input-height);
        padding: var(--contact-mobile-input-padding-y) var(--contact-mobile-input-padding-x);
        font-size: var(--pixso-fs-16);
        line-height: var(--pixso-lh-16);
        border-radius: var(--contact-input-radius);
    }

    .form-textarea {
        min-height: var(--contact-mobile-textarea-height);
    }

    .submit-btn {
        min-width: 0;
        width: 100%;
        padding: var(--pixso-gap-sm) var(--pixso-fs-20);
        font-size: var(--pixso-fs-16);
        line-height: var(--pixso-lh-16);
    }

    .banner-company__name {
        font-size: var(--pixso-fs-20);
    }

    .banner-company__en {
        font-size: var(--pixso-fs-12);
    }
}
</style>
